// Initialize slider for mobile version
var rewardMobile = document.querySelector(".reward-section-mobile");
if (rewardMobile && rewardMobile.children.length > 0 && rewardMobile.parentNode && rewardMobile.parentNode.nodeType === 1) {
  try {
    var slider = tns({
      container: rewardMobile,
      items: 1,
      slideBy: 1,
      nav: true,
      controls: false,
      loop: false,
      mouseDrag: true,
      autoplay: false,
      autoHeight: true,
      gutter: 0
    });
  } catch (e) {
    console.error('Reward mobile slider init error:', e);
  }
}